import cls from '@UI/crypto_exchange/desktop/components/modals/ModalWrapper/ModalWrapper.module.scss'
import { SVGProps } from 'react'

export const ArrowDownIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16" fill="none" {...props}>
    <path
      d="M19.465 6v2.5L16 11l-3.465-2.5V6L16 8.5 19.465 6zM10.02 9.636H3V7.364h7.02v2.272zm18.98 0h-7.02V7.364H29v2.272z"
      fill="currentColor"
    />
  </svg>
)

export const ArrowUpIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="icon" {...props}>
    <path d="M16 9v2l-4 4.24L8 11V9h8z" fill="currentColor"></path>
  </svg>
)

export const DoubleDownArrowIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16" fill="none" {...props}>
    <path d="M19.484 3v2.676L16.02 8.353l-3.465-2.677V3l3.465 2.676L19.484 3z" fill="currentColor" />
    <path
      d="M19.484 7.647v2.676L16.02 13l-3.465-2.676V7.648l3.465 2.676 3.464-2.676zM10.04 9.216H3.02V6.784h7.02v2.432zm18.98 0H22V6.784h7.02v2.432z"
      fill="currentColor"
    />
  </svg>
)

export const ArrowUpHookIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16" fill="none" {...props}>
    <path
      d="M19 9h2l-3-3-3 3h2.256v.612c0 .884-.783 1.602-1.75 1.602-.966 0-1.75-.718-1.75-1.602V3H12v6.612C12 11.48 13.569 13 15.5 13c1.932 0 3.5-1.521 3.5-3.388V9z"
      fill="currentColor"
    />
  </svg>
)

export const ArrowDownHookIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16" fill="none" {...props}>
    <path
      d="M19 9h2l-3 3-3-3h2.256V6.388c0-.884-.783-1.602-1.75-1.602-.966 0-1.75.718-1.75 1.602V13H12V6.388C12 4.52 13.569 3 15.5 3 17.432 3 19 4.521 19 6.388V9z"
      fill="currentColor"
    />
  </svg>
)

export const ArrowUpRightIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16" fill="none" {...props}>
    <path
      d="M15.077 4.308h4.615v4.615l-1.846-1.846-5.077 5.077-.923-.923 5.077-5.077-1.846-1.846z"
      fill="currentColor"
    />
  </svg>
)

export const DoubleUpArrowIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16" fill="none" {...props}>
    <path d="M12.555 13v-2.676l3.465-2.677 3.465 2.677V13l-3.465-2.676L12.555 13z" fill="currentColor" />
    <path
      d="M12.555 8.352V5.677L16.02 3l3.465 2.676v2.676L16.02 5.676l-3.465 2.676zM22 6.784h7.02v2.432H22V6.784zm-18.98 0h7.02v2.432H3.02V6.784z"
      fill="currentColor"
    />
  </svg>
)

export const DownRightArrowIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16" fill="none" {...props}>
    <path
      d="M15.077 11.692h4.615V7.077l-1.846 1.846-5.077-5.077-.923.923 5.077 5.077-1.846 1.846z"
      fill="currentColor"
    />
  </svg>
)

export const AccountArrowIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="css-1xv229u" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.934 12l3.89 3.89-1.769 1.767L8.398 12l1.768-1.768 3.89-3.889 1.767 1.768-3.889 3.89z"
      fill="currentColor"
    ></path>
  </svg>
)

export const CloseIcon = (props: any) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11 1L1 11" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M1 1L11 11" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
)

export const SendToEmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 144 144" {...props}>
    <defs>
      <path id="a" d="M0 0h144v144H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <path fill="#9A6D48" fillRule="nonzero" mask="url(#b)" d="M16 62h112v64H16z" />
      <path
        fill="#BB8961"
        fillRule="nonzero"
        d="M38 118h68a4 4 0 014 4v4H34v-4a4 4 0 014-4zm-4-46h76v32a4 4 0 01-4 4H38a4 4 0 01-4-4V72z"
        mask="url(#b)"
      />
      <path fill="#755236" fillRule="nonzero" d="M72 30l56 32-56 32-56-32 56-32z" mask="url(#b)" />
      <path
        fill="#D4A077"
        fillRule="nonzero"
        d="M106 18a4 4 0 014 4v50.29L72 94 34 72.29V22a4 4 0 014-4h68z"
        mask="url(#b)"
      />
      <path
        fill="#755236"
        fillRule="nonzero"
        d="M86 72v4H58v-4h28zm4-8v4H54v-4h36zm6-8v4H48v-4h48zM71.64 28A8.42 8.42 0 0179 32.12l-4.27 2.45c-.55-1.13-1.73-1.8-3.16-1.8a3.56 3.56 0 00-3.68 3.73 3.56 3.56 0 003.68 3.73c1.43 0 2.64-.67 3.16-1.8L79 40.85A8.34 8.34 0 0171.64 45 8.4 8.4 0 0163 36.5a8.4 8.4 0 018.64-8.5zm7.86 6a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"
        mask="url(#b)"
      />
    </g>
  </svg>
)
